"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.string,
    value: _propTypes.string,
    onChange: _propTypes.func,
    vertical: _propTypes.bool,
    options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: _propTypes.string,
      text: _propTypes.string
    })).isRequired,
    accessible: _propTypes.bool,
    isReversed: _propTypes.bool,
    isFullWidth: _propTypes.bool,
    customProperties: _propTypes.object,
    color: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    textColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    isMobile: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    onChange: function onChange() {},
    selectedId: '',
    vertical: false,
    accessible: true,
    isReversed: false,
    isFullWidth: false,
    color: 'secondary',
    isMobile: false,
    textColor: 'neutral'
  }
};
exports.default = _default;